export const loadProfileData = () => ({
  type: "LOAD_PROFILE_DATA_REQUEST",
});

export const loadProfileDataFailed = error => ({
  type: "LOAD_PROFILE_DATA_FAILED",
  error,
});

export const updateProfileData = profileData => ({
  type: "UPDATE_PROFILE_DATA_REQUEST",
  profileData,
});



// WEBPACK FOOTER //
// ./src/scenes/EditProfilePage/actions.js